<template>
  <div
    ref="dropdownActivators"
    class="d-flex-inline dropdown-toggle"
  >
    <slot>
      <m-button
        id="dropdown-activator-shadow"
        :variant="triggerVariant"
        :icon-variant="triggerIconVariant"
        :theme="triggerTheme"
        :size="triggerSize"
        :label="triggerLabel"
        :disabled="triggerDisabled"
        @click="$emit('dropdown-trigger', true)"
        @keydown.enter="$emit('dropdown-trigger', true)"
      />
    </slot>
  </div>
</template>

<script>
import MButton from '../../Button';

export default {
  name: 'DropdownTrigger',
  components: { MButton },
  props: {
    triggerLabel: {
      type: String,
      default: 'Button',
    },
    triggerVariant: {
      type: String,
      default: 'icon-right',
    },
    triggerIconVariant: {
      type: String,
      default: 'dropdown',
    },
    triggerTheme: {
      type: String,
      default: 'primary',
    },
    triggerSize: {
      type: String,
      default: 'default',
    },
    triggerDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
